export const WHATSAPP_NUMBER = "5532999103556";
export const WHATSAPP_DISPLAY = "(32) 99910-3556";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_CODES = {
  downloader: "1055158",
  ntdown: "19367",
};

export const PLANS = [
  {
    id: "1m",
    name: "1 Mês",
    days: "30 dias",
    price: "R$ 45,00",
    tagline: "Para conhecer",
    popular: false,
    features: [
      "2 telas simultâneas",
      "Qualidade 4K / Full HD",
      "Tecnologia P2P anti-trava",
      "Ativação por código",
      "Suporte no WhatsApp",
    ],
  },
  {
    id: "3m",
    name: "3 Meses",
    days: "90 dias",
    price: "R$ 112,90",
    tagline: "Economize R$ 22",
    popular: false,
    features: [
      "2 telas simultâneas",
      "Qualidade 4K / Full HD",
      "Tecnologia P2P anti-trava",
      "Canais, filmes e séries",
      "Suporte prioritário",
    ],
  },
  {
    id: "6m",
    name: "6 Meses",
    days: "180 dias",
    price: "R$ 220,00",
    tagline: "Mais vendido",
    popular: true,
    features: [
      "2 telas simultâneas",
      "Qualidade 4K / Full HD",
      "Tecnologia P2P anti-trava",
      "Acesso imediato",
      "Suporte prioritário 24/7",
    ],
  },
  {
    id: "9m",
    name: "9 Meses",
    days: "273 dias",
    price: "R$ 362,20",
    tagline: "Super desconto",
    popular: false,
    features: [
      "2 telas simultâneas",
      "Qualidade 4K / Full HD",
      "Tecnologia P2P anti-trava",
      "Estabilidade premium",
      "Atendimento VIP",
    ],
  },
  {
    id: "12m",
    name: "12 Meses",
    days: "360 dias",
    price: "R$ 399,99",
    tagline: "Melhor custo-benefício",
    popular: true,
    features: [
      "2 telas simultâneas",
      "Maior economia do ano",
      "Tecnologia P2P anti-trava",
      "Acesso total liberado",
      "Suporte exclusivo WhatsApp",
    ],
  },
];

export const MSG = {
  hero: "Olá! Quero contratar o NOVA ÉRA com 2 telas simultâneas!",
  plan: (name, price) =>
    `Olá! Quero contratar o plano ${name} (${price}) do NOVA ÉRA com 2 telas simultâneas!`,
  renew: "Olá! Quero renovar meu acesso NOVA ÉRA. Seguem meus dados:",
  renewPlan: (name, price) =>
    `Olá! Quero RENOVAR meu NOVA ÉRA no plano ${name} (${price}).`,
  activation: "Olá! Já instalei o app NOVA ÉRA e preciso do meu código de ativação.",
  help: "Olá! Preciso de ajuda com a instalação do NOVA ÉRA.",
  info: "Olá! Quero saber mais sobre o NOVA ÉRA e as 2 telas simultâneas.",
};

export const FAQ_HOME = [
  {
    q: "O que é o NOVA ÉRA?",
    a: "O NOVA ÉRA é um aplicativo de streaming com tecnologia P2P que libera canais ao vivo, filmes e séries em qualidade 4K/Full HD. Todos os planos incluem 2 telas simultâneas, para assistir em dois aparelhos ao mesmo tempo.",
  },
  {
    q: "Como recebo meu acesso após a contratação?",
    a: "Após a confirmação pelo WhatsApp, você recebe um código de ativação. Basta instalar o app NOVA ÉRA (pela página Download), inserir o código e começar a assistir em minutos.",
  },
  {
    q: "Em quais aparelhos o NOVA ÉRA funciona?",
    a: "TV Box Android, Smart TVs com Android TV, Fire TV Stick e celulares Android. A instalação é guiada e feita pelos aplicativos Downloader ou NtDown.",
  },
  {
    q: "Posso assistir em 2 telas ao mesmo tempo?",
    a: "Sim! Essa é a grande vantagem do NOVA ÉRA: todos os planos incluem 2 telas simultâneas, sem custo adicional. Futebol na sala e novela no quarto, ao mesmo tempo.",
  },
  {
    q: "Como funciona a renovação?",
    a: "Na página Renovação você escolhe o plano e chama no WhatsApp. A renovação cai na hora e você continua usando o mesmo código de ativação, sem reinstalar nada.",
  },
  {
    q: "Como renovar minha Nova Era TV?",
    a: "A renovação (recarga Nova Era) é feita pela página Renovação ou direto no WhatsApp: escolha o plano, confirme o pagamento via Pix e o acesso é estendido no mesmo código de ativação — o código de renovação da Nova Era é o mesmo que você já usa.",
  },
  {
    q: "Qual é o código NovaEra para instalar o app?",
    a: "Os códigos NovaEra de instalação ficam na página Download, sempre atualizados: um para o app Downloader e outro para o NtDown. Depois de instalar, você ativa o app com o código recebido no WhatsApp.",
  },
];
